// src/Contact.js
import React from "react";
import { motion } from "framer-motion";
import "./Contact.css";

function Contact() {
  return (
    <motion.div
      className="contact-container"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {/* Información de Contacto */}
      <div className="contact-info">
        {/* Correo */}
        <div className="info-item">
          <ion-icon name="mail-outline"></ion-icon>
          <a href="mailto:javiercobalto@gmail.com">javiercobalto@gmail.com</a>
        </div>

        {/* Teléfono */}
        <div className="info-item">
          <ion-icon name="call-outline"></ion-icon>
          <span>+34 692 811 624</span>
        </div>

        {/* Instagram */}
        <div className="info-item">
          <ion-icon name="logo-instagram"></ion-icon>
          <a
            href="https://www.instagram.com/javiercobalto/"
            target="_blank"
            rel="noopener noreferrer"
          >
            @javiercobalto
          </a>
        </div>
      </div>

      {/* Formulario */}
      <div className="contact-box">
        <h2 className="form-title">Contacta con nosotros</h2>
        <form
          action="https://formsubmit.co/6c69ea8ee0d6ecf792324ec4c45e6048" 
          method="POST"
          className="contact-form"
        >
          <div className="form-group">
            <label htmlFor="first-name">Nombre</label>
            <input
              type="text"
              id="first-name"
              name="first_name"
              placeholder="Nombre"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="last-name">Apellido</label>
            <input
              type="text"
              id="last-name"
              name="last_name"
              placeholder="Apellido"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Teléfono</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Teléfono"
              pattern="[0-9]*"
              inputMode="numeric"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Mensaje</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              placeholder="Escribe tu mensaje"
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">
            Enviar
          </button>
        </form>
      </div>
    </motion.div>
  );
}

export default Contact;